// src/firebase.js
// ─────────────────────────────────────────────
// YOUR FIREBASE PROJECT IS ALREADY SET UP.
// This file wires up Auth + Firestore.
// No changes needed unless you create a new project.
// ─────────────────────────────────────────────
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey:            'AIzaSyCGkWPIRl0flMlz1wr_x1Xm1LTzls0JeWo',
  authDomain:        'the-waste-game-511d5.firebaseapp.com',
  projectId:         'the-waste-game-511d5',
  storageBucket:     'the-waste-game-511d5.firebasestorage.app',
  messagingSenderId: '697120714462',
  appId:             '1:697120714462:web:33b02ea7c52ec5a7d25c4f',
};

const app  = initializeApp(firebaseConfig);

export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);
export default app;
